// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1_pXYAK1lqD18OgW6AmAca","title":"bQYEg5kdxmq42aTxiCQbM"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MortgageBanner/SimpleMortgageBanner.scss
// module id = 1830
// module chunks = 0